import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage.js';
import ScientificOutputs from './Pages/ScientificOutputs';
import NematodeMap from './Pages/NematodeMap.js';
import NematodeMapData from './Pages/NematodeMapData.js';
import DotsEcoBlogs from './Pages/DotsEcoBlogs.js';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/ScientificOutputs' element={<ScientificOutputs />} />
          <Route path='/NematodeMap' element={<NematodeMap />} />
          <Route path='/NematodeMapData' element={<NematodeMapData />} />
          <Route path='/DotsEcoBlogs' element={<DotsEcoBlogs />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;